import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";

import Menu from "../../../components/Menu";
import Loading from "../../../components/Loading";
import api from "../../../services/api";
import { useNavigate } from "react-router";

const initialState = {
    quantidade: "",
    titulo_id: "",
    descricao: ""
}

export default function Solicitacoes() {
    const [data, setData] = useState([]);
    const [titulos, setTitulos] = useState([]);

    const [form, setForm] = useState({...initialState});

    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const navigate = useNavigate();
    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get("estoque/solicitacoes").then((response) => {
            setData(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }, []);

    const fetchTitulos = useCallback(() => {
        api.get("titulos").then((response) => {
            setTitulos(response.data);
        }).catch((error) => {
            showError(error);
        });
    }, []);

    const handleSubmit = () => {
        if (form.titulo_id === null) {
            toast.current.show({ summary: "Aviso", severity: "warn", detail: "Selecione um TÍTULO para continuar!" });
            return;
        }

        if (form.quantidade <= 0) {
            toast.current.show({ summary: "Aviso", severity: "warn", detail: "Quantidade precisa ser maior do que ZERO!" });
            return;
        }

        setIsLoading(true);
        api.post("estoque/solicitar-palete", form).then((response) => {
            fetchData();
            setIsLoading(false);
            showSuccess(response);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }

    const onHide = () => {
        setIsVisible(false);
    }

    const onShow = () => {
        setIsVisible(true);
    }

    useEffect(() => {
        fetchData();
        fetchTitulos();
    }, [fetchData, fetchTitulos]);

    if (isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Dialog
                header="Solicitar Palete"
                onHide={onHide}
                style={{ minWidth: "35vw" }}
                visible={isVisible}
            >
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="">Título: </label>
                        <Dropdown
                            filter
                            filterMatchMode="contains"
                            onChange={e => setForm({ ...form, titulo_id: e.target.value })}
                            options={titulos}
                            optionLabel="descricao"
                            optionValue="id"
                            value={form.titulo_id}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="">Quantidade: </label>
                        <InputNumber
                            onChange={e => setForm({ ...form, quantidade: e.value })}
                            value={form.quantidade}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="observacao">Observação: </label>
                        <InputTextarea
                            onChange={e => setForm({ ...form, descricao: e.target.value })}
                            placeholder="Qualquer observação..."
                            value={form.descricao}
                        />
                    </div>
                    <div className="p-d-flex p-flex-row">
                        <Button
                            className="p-button-secondary p-mr-2"
                            label="Cancelar"
                            onClick={onHide}
                        />

                        <Button
                            className="p-button-success p-ml-2"
                            label="Salvar"
                            onClick={handleSubmit}
                        />
                    </div>
                </div>
            </Dialog>

            <Card
                className="p-m-1"
                title="Solicitações"
            >
                <div className="p-d-flex p-flex-row p-jc-end">
                    <Button
                        className="p-m-1"
                        icon="pi pi-arrow-left"
                        onClick={() => {
                            navigate("/estoque/fio")
                        }}
                        title="Clique para voltar ao estoque de fio"
                    />
                    <Button
                        className="p-m-1 p-button-success"
                        icon="pi pi-plus"
                        onClick={onShow}
                        title="Clique para SOLICITAR um ou mais paletes..."
                    />
                </div>

                <DataTable
                    emptyMessage="Nenhuma solicitação encontrada."
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column header="ID" field="id" sortable />
                    <Column header="Título" field="titulo" sortable />
                    <Column header="Quantidade" field="quantidade" sortable />
                    <Column header="Data" field="data" />
                    <Column header="Situação" field="situacao" />
                </DataTable>
            </Card>
        </div>
    )
}